import React, { Component } from 'react';
//import { NavLink } from "react-router-dom"
import { authentication } from '../services/Authentication';

import { config } from '../Constants';
import helpers from '../Function';


import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalFooter from "react-bootstrap/ModalFooter";
import ModalTitle from "react-bootstrap/ModalTitle";

import TextareaAutosize from '@material-ui/core/TextareaAutosize';

import $ from "jquery";

export default class ContactUs extends Component {

    constructor(props) {
        super(props);
        const { name, user_id, user_type, jwt, user_permission } = authentication.currentUserValue;

        this.state = {
            jwt: jwt,
            user_permission: user_permission,
            miss_su: helpers.getUserType(user_type, "su"),
            updateIsOpen: false,
            create_by: name,
            create_by_id: user_id,
            usertype: user_type,
            userid: user_id,
            add_contactth: '',
            add_contact: '',
            add_tel1: '',
            add_tel2: '',
            add_mail: '',
            add_id: '',
            add_weblink: '',
            spinner: true,
        };

        $("#root").addClass("wrapper");
        $("body").removeClass("login-page");

        this.submitAdd = this.submitAdd.bind(this);
        this.closeAdd = this.closeAdd.bind(this);

        this.change = this.change.bind(this)
        this.closeModelUpdate = this.closeModelUpdate.bind(this);

        this.openView();
    }

    openView() {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/getContactUs/', requestOptions)
                .then(res => res.json())
                .then(dataDetail => {
                    var data = dataDetail.data;
                    if (data.length > 0) {
                        this.setState({
                            add_id: data[0]._id,
                            add_contact: data[0].contact,
                            add_contactth: data[0].contactth,
                            add_tel1: data[0].telephone1,
                            add_tel2: data[0].telephone2,
                            add_mail: data[0].email,
                            add_weblink: data[0].weblink,
                            spinner:false,
                        });
                    } else {
                        this.setState({
                            add_id: '',
                            add_contact: '',
                            add_contactth: '',
                            add_tel1: '',
                            add_tel2: '',
                            add_mail: '',
                            add_weblink:'',
                            spinner:false
                        });
                    }
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    submitAdd() {
        try {
            console.log(this.state.add_contact)
            if (!this.state.add_contactth) {
                alert('ไม่พบข้อมูลการติดต่อ');
                return;
            }
    
            if (!this.state.add_contact) {
                alert('ไม่พบข้อมูล Contact Us');
                return;
            }
    
            if (!this.state.add_tel1) {
                alert('ไม่พบข้อมูลเบอร์โทร');
                return;
            }
    
            if (!this.state.add_mail) {
                alert('ไม่พบข้อมูลเมล');
                return;
            }
    
            const requestOptions = {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    id: this.state.add_id,
                    contact: this.state.add_contact,
                    contactth: this.state.add_contactth,
                    telephone1: this.state.add_tel1,
                    telephone2: this.state.add_tel2,
                    email: this.state.add_mail,
                    weblink: this.state.add_weblink,
                    active_status: this.state.active ? 1 : 0,
                    createby: this.state.create_by,
                    createby_id: this.state.create_by_id
                })
            };
    
            fetch(config.url.API_URL + '/createContactUs', requestOptions)
                .then(res => res.json())
                .then(data => {
                    this.setState({
                        updateIsOpen: true
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }
    closeAdd() {
        this.setState({
            add_contact: '',
            add_tel1: '',
            add_tel2: '',
            add_mail: '',
            add_weblink:''
        });
    }

    closeModelUpdate() {
        this.setState({ updateIsOpen: false });
        this.openView();
    }

    change(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }


    render() {
        return (
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0 text-dark">Contact Us</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item active">Contact Us</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="content">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                </div>
                                <div className="card-body">
                                    <form id="form-submit">
                                        <div className="row mb-3">
                                            <div className="col-sm-3 text-right">ข้อมูลการติดต่อ<span style={{ color: 'red' }}>*</span></div>
                                            <div className="col-sm-5">
                                                <TextareaAutosize className="form-control" name="add_contactth" rowsMin={4} defaultValue={this.state.add_contactth} onChange={this.change} />
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3 text-right">Contact Us<span style={{ color: 'red' }}>*</span></div>
                                            <div className="col-sm-5">
                                                <TextareaAutosize className="form-control" name="add_contact" rowsMin={4} defaultValue={this.state.add_contact} onChange={this.change} />
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3 text-right">Tel<span style={{ color: 'red' }}>*</span></div>
                                            <div className="col-sm-5">
                                                <input type="text" className="form-control" id="add_tel1" name="add_tel1" defaultValue={this.state.add_tel1} onChange={this.change} />
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3 text-right">Fax</div>
                                            <div className="col-sm-5">
                                                <input type="text" className="form-control" id="add_tel2" name="add_tel2" defaultValue={this.state.add_tel2} onChange={this.change} />
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3 text-right">Email<span style={{ color: 'red' }}>*</span></div>
                                            <div className="col-sm-5">
                                                <input type="text" className="form-control" id="add_mail" name="add_mail" defaultValue={this.state.add_mail} onChange={this.change} />
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-3 text-right">ลิงก์ HAPPY LIVING BLOG</div>
                                            <div className="col-sm-5">
                                                <input type="text" className="form-control" id="add_weblink" name="add_weblink" defaultValue={this.state.add_weblink} onChange={this.change} />
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="card-footer">
                                    <center><div><button className="btn btn-danger" onClick={this.closeAdd}>ยกเลิก</button>&nbsp;&nbsp;
                                    {(this.state.user_permission[18].permission == 1 &&
                                            <button className="btn btn-success" onClick={this.submitAdd}>บันทึก</button>
                                        )}
                                    </div></center>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Modal show={this.state.updateIsOpen} onHide={this.closeModelUpdate} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        บันทึกรายการสำเร็จ
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-success" onClick={this.closeModelUpdate}>ตกลง</button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}